import { Paragraph } from '@finviz/website'
import classnames from 'classnames'
import React from 'react'

export type PopoverTableRowData = Array<{ value: string | number; className?: string; colSpan?: number; href?: string }>

export function ChartEventPopoverTableRow({ data }: { data: PopoverTableRowData }) {
  return (
    <tr>
      {data.map(({ value, className, colSpan, href }, index) => (
        <td key={`${index}-${value}`} colSpan={colSpan}>
          <Paragraph
            as={href ? 'a' : undefined}
            href={href}
            size="small"
            className={classnames(
              {
                'whitespace-nowrap pr-4': index === 0,
                'text-gray-500 dark:text-gray-300 ': !className && index === 0,
              },
              className
            )}
          >
            {value}
          </Paragraph>
        </td>
      ))}
    </tr>
  )
}
